// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcm_a bhe_ea bhe_kb bhe_js bhe_sl bhe_wj"};